import Popup from 'reactjs-popup';
import 'reactjs-popup/dist/index.css';
import './reasonPopup.scss'
 
export default function ReasonPopup({reason,firstWord}) {

    return (
        <div>
          
            <Popup trigger=
                {  <h4 className='text_inPopUp' dir='rtl'>{firstWord}</h4>}
                position="bottom center">
                <div className='ReasonPopup_div_container' dir='rtl'><p dir='rtl'>{reason}</p></div>
            </Popup>
        </div>
    )
};